<template>
    <div>
        <el-time-select v-model="time" :picker-options="{
            step: '00:15',
        }" :placeholder="config.placeholder" clearable>
        </el-time-select>
    </div>
</template>

<script>
export default {
    name: 'FromTime',
    components: {},
    props: {
        value: {
            type: String,
            default: ''
        },
        config: {
            type: Object,
            default: {}
        }
    },
    model: {
        event: 'change'
    },
    watch: {
        time(value) {
            this.$emit('change', value)
        },
        value(value) {
            this.time = value
        }
    },
    data() {
        return {
            time: this.value
        }
    },
    methods: {

    }
}
</script>
